import { render, staticRenderFns } from "./changePasswordProxy.vue?vue&type=template&id=26b76bc3&scoped=true&"
import script from "./changePasswordProxy.vue?vue&type=script&lang=js&"
export * from "./changePasswordProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b76bc3",
  null
  
)

export default component.exports